import React from 'react';
import { ErrorRounded } from '@mui/icons-material';
import { Box, Paper } from '@mui/material';
import { Main } from './FullPageError.styles';

const FullPageError: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <Main>
      <Paper
        sx={{
          padding: '10% 20%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <ErrorRounded color="error" fontSize="large" />
        <h1>Uh oh!</h1>
        <strong>An Error Occurred</strong>
        <Box
          sx={{
            marginY: '20px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {children}
        </Box>
      </Paper>
    </Main>
  );
};

export default FullPageError;
